module.exports = __webpack_public_path__ + "static/img/Charlie_Dixon_desktop.208966d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Dixon_desktop.jpg
// module id = xGkv
// module chunks = 0